import Joi from 'joi';
import _ from 'lodash';
import { TManufacturerProductIdType } from '../../generated/graphql';
import { clearableField } from '../shared/clearableField';
import { productCustomsFields } from './shared';

export const productIdentifierFields = {
  value: Joi.number().positive().required(),
  hsCode: Joi.string()
    .custom((value, helpers) => {
      const regex = /^\d{4}\.\d{2}(\.\d{2})?$/;
      if (!regex.test(value)) return helpers.message({ custom: 'HS Code must be 0000.00 or 0000.00.00' });

      return value;
    })
    .required(),
  quantity: Joi.number().positive().required(),
  description: Joi.string().max(60).trim().required(),
  country: Joi.string().trim().required(),
  originCriterion: clearableField(Joi.string().trim()),
  sku: clearableField(Joi.string().trim()),
  manufacturerNsProductId: clearableField(Joi.string().trim()),
  manufacturerProductId: clearableField(Joi.string().trim()),
  manufacturerProductIdType: clearableField(Joi.string().valid(...Object.values(TManufacturerProductIdType)))
};

export const getProductSchema = () => {
  const schema = Joi.object()
    .unknown(false)
    .keys({
      id: Joi.forbidden(),
      ...productIdentifierFields
    })
    .and('manufacturerProductId', 'manufacturerProductIdType', { isPresent: (value) => value != null });

  return schema;
};

export const getProductDefaultValues = (product?: Record<string, any> | null) => {
  return _.pick(product || {}, productCustomsFields);
};
